import React from "react";


const Layout2 = ({ children }) => {
  return (
    <>
      
      <main style={{ minHeight: "80vh" }}>{children}</main>
      
      
    </>
  );
};

export default Layout2;